/**
 * No-operation functions
 * Used for readability, as well as to prevent creating extra empty arrow functions
 */
export const noOp = () => {};
export const asyncNoOp = async () => {};
